<script>
import inView from 'in-view';

/**
 * Will render the default `slot` when element enters once or it's already in the viewport
 */
export default {
    name: 'InView',
    data() {
        return {
            entered: false,
        };
    },
    computed: {
        selector() {
            return `js-in-view--${this._uid}`;
        },
    },
    mounted() {
        this.checkInView();
    },
    methods: {
        checkInView() {
            if (inView.is(this.$el) && !this.entered) {
                this.entered = true;

                return;
            }

            inView(`.${this.selector}`).once('enter', () => {
                this.entered = true;
            });
        },
    },
    render(h) {
        if (!this.$scopedSlots.default) {
            return;
        }

        const children = this.entered ? this.$scopedSlots.default() : [];

        return h('div', { class: `in-view ${this.selector}` }, children);
    },
};
</script>
